<template>
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="所属车场" prop="spaceId">
              <selectSearch style="width: 100%;"  v-model="searchForm.spaceId" :dicData="spaceIdList" @change="spaceIdChange"></selectSearch>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属区域" prop="regionId">

              <el-select v-model="searchForm.regionId" style="width:100%" placeholder="所属区域" clearable>
                <el-option
                  v-for="(item, index) in regionList"
                  :key="index"
                  :label="item.spaceName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车位编号" prop="name">
              <el-input
                clearable
                v-model="searchForm.name"
                placeholder="车位编号"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="子/母车位" prop="isDouble">
                <el-select v-model="searchForm.isDouble" style="width:100%" placeholder="子/母车位" clearable>
                <el-option
                  v-for="item in isDoubleData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车位性质" prop="parkingSpaceNature">
              <el-select v-model="searchForm.parkingSpaceNature" style="width:100%" placeholder="车位性质" clearable>
                <el-option
                  v-for="item in parkingSpaceNatureDict"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="缴费状态" prop="paymentStatus">
              <el-select v-model="searchForm.paymentStatus" style="width:100%" placeholder="缴费状态" clearable>
                <el-option
                  v-for="item in paymentStatusData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车位状态" prop="status">
                <el-select v-model="searchForm.spaceStatus" style="width:100%" placeholder="车位状态" clearable>
                <el-option
                  v-for="item in spaceStatusData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="归属人姓名" prop="source">
                <el-input
                clearable
                v-model="searchForm.personName"
                placeholder="归属人姓名"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="归属人电话" prop="personPhone">
                <el-input
                clearable
                v-model="searchForm.personPhone"
                placeholder="归属人电话"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="剩余天数" prop="remainDays">
              <el-input
                clearable
                v-model="searchForm.remainDays"
                placeholder="剩余天数"
                type="number"
                maxlength="100"
              ></el-input>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期止" prop="endTimeList">

              <el-date-picker
              style="width:48%;"
              v-model="searchForm.buyEndTimeStart"
              type="date"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="到"
              placeholder="开始时间"

            >
            </el-date-picker>
            <span style="width:4%;display: inline-block;text-align: center;">到</span>
            <el-date-picker
              style="width:48%;"
              v-model="searchForm.buyEndTimeEnd"
              type="date"
              value-format="yyyy-MM-dd 23:59:59"
              range-separator="到"

              placeholder="结束时间"
            >
            </el-date-picker>

            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="名下车牌号" prop="searchPlateNumber">
              <el-input
                clearable
                v-model="searchForm.searchPlateNumber"
                placeholder="名下车牌号"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <div style="float:right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
        <template slot="strategyName" slot-scope="scope">
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              <div v-html="scope.row.strategyName"></div>
            </div>
            <div class="txtOver" v-html="scope.row.strategyName"></div>
          </el-tooltip>
        </template>
        <template slot="devicesName" slot-scope="scope">
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              <div v-html="scope.row.devicesName"></div>
            </div>
            <div class="txtOver" v-html="scope.row.devicesName"></div>
          </el-tooltip>
        </template>
        <template slot="menuLeft">
          <el-button type="primary" v-if="permission.spaceAdd" icon="el-icon-plus" size="small" @click="addRecord">
            新 增</el-button
          >
          <el-button type="primary" v-if="permission.spaceImport" icon="el-icon-plus" size="small" @click="uploadRecord">
            导 入</el-button
          >
          <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          v-if="permission.spaceRefund"
          @click="openRefundDialog"
        >退 款
        </el-button>
          <span>&nbsp;&nbsp;&nbsp;</span>
        <span>空闲	 {{ statusCountNew.freeNum }} </span>
        <span>已逾期 {{ statusCountNew.outNum }} </span>
        <span>正常 {{ statusCountNew.normalNum }} </span>
        <span>已出租 {{ statusCountNew.leasedNum }} </span>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>
          <el-button  v-if="permission.spaceEdit" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>
          <el-button v-if="(scope.row.spaceStatus==2 || scope.row.spaceStatus==3) && scope.row.paymentStatus!=3" type="text" size="small" @click="payRecord(scope.row)">缴费 </el-button>
          <el-button v-if="scope.row.spaceStatus==3 && scope.row.paymentStatus==2" v-show="permissionList.breakApplyBtn" type="text" size="small" @click="breakPayRecord(scope.row)">申请断缴 </el-button>
          <el-button v-if="scope.row.paymentStatus==3" v-show="permissionList.approveBtn"  type="text" size="small" @click="approveRecord(scope.row)">审核 </el-button>
          <el-button v-if="scope.row.spaceStatus==2 || scope.row.spaceStatus==3" type="text" size="small" @click="payLogRecord(scope.row)">缴费记录 </el-button>
          <el-button v-if="permission.spaceRemove"  type="text" size="small" @click="removeRecord(scope.row)">删除 </el-button>
        </template>
      </avue-crud>
      <hr-dialog title="新增" :allowFull="false" width="60%" :visible.sync="addFormVisible">
        <template slot="body">
          <AddForm
            @cancle="recordCancle"
            v-if="addFormVisible"
            @success="recordSuccess"
            :spaceId="this.searchForm.spaceId"
          ></AddForm>
        </template>
      </hr-dialog>
      <hr-dialog title="查看" :allowFull="false" width="60%" :visible.sync="viewFormVisible">
        <template slot="body">
          <ViewForm
            @cancle="recordCancle"
            v-if="viewFormVisible"
            :row="formRow"
            @success="recordSuccess"
          ></ViewForm>
        </template>
      </hr-dialog>
      <hr-dialog title="查看" :allowFull="false" width="60%" :visible.sync="viewFormVisible">
        <template slot="body">
          <viewForm
            @cancle="recordCancle"
            v-if="viewFormVisible"
            :row="formRow"
            @success="recordSuccess"
          ></viewForm>
        </template>
      </hr-dialog>
      <hr-dialog title="缴费" :allowFull="false" width="60%" :visible.sync="payFormVisible">
        <template slot="body">
          <PayForm
            @cancle="recordCancle"
            v-if="payFormVisible"
            :row="formRow"
            @success="recordSuccess"
            :spaceId="this.searchForm.spaceId"
          ></PayForm>
        </template>
      </hr-dialog>
      <hr-dialog title="申请断缴" :allowFull="false" width="60%" :visible.sync="breakPayApplyFormVisible">
        <template slot="body">
          <BreakPayApplyForm
            @cancle="recordCancle"
            v-if="breakPayApplyFormVisible"
            :row="formRow"
            @success="recordSuccess"
            :spaceId="this.searchForm.spaceId"
          ></BreakPayApplyForm>
        </template>
      </hr-dialog>
      <hr-dialog title="审核" :allowFull="false" width="60%" :visible.sync="approveFormVisible">
        <template slot="body">
          <ApproveForm
            @cancle="recordCancle"
            v-if="approveFormVisible"
            :row="formRow"
            @success="recordSuccess"
            :spaceId="this.searchForm.spaceId"
          ></ApproveForm>
        </template>
      </hr-dialog>
      <hr-dialog title="编辑" :allowFull="false" width="60%" :visible.sync="editFormVisible">
        <template slot="body">
          <EditForm
            @cancle="recordCancle"
            v-if="editFormVisible"
            :row="formRow"
            @success="recordSuccess"
          ></EditForm>
        </template>
      </hr-dialog>
      <hr-dialog title="缴费记录" :allowFull="false" width="60%" :visible.sync="payLogVisible">
        <template slot="body">
          <PayLog
            v-if="payLogVisible"
            :row="formRow"
          ></PayLog>
        </template>
      </hr-dialog>
      <hr-dialog title="退费" :allowFull="false" width="60%" :visible.sync="refundVisible">
        <template slot="body">
          <refundForm
          @cancle="recordCancle"
          @success="recordSuccess"
            v-if="refundVisible"
            :row="formRow"
          ></refundForm>
        </template>
      </hr-dialog>
      <ImportForm
      :exportApi="`/api/v4ward/car/parking/space/exportTemplate`"
      :submitApi="`/api/v4ward/car/parking/space/import`"
      :spaceId="this.searchForm.spaceId"

      @success="importSuccess"

      :visible.sync="isImportDialogShow"
    ></ImportForm>
    </basic-container>
  </template>
  <script>

  import { getParkList,spacePage,spaceRemove,spaceStatusCount } from './index.js';
  import { mapGetters } from 'vuex';
  import searchFromShow from '@/components/search-form-show/index';
  import AddForm from './addForm.vue';
  import ViewForm from './viewForm.vue';
  import LeaseViewForm from './leaseViewForm.vue';
  import EditForm from './editForm.vue';
  import PayForm from './payForm.vue';
  import BreakPayApplyForm from './breakPayApplyForm.vue';
  import ApproveForm from './approveForm.vue';
  import refundForm from './refundForm.vue';
  import PayLog from './payLog.vue';
  import ImportForm from "./importForm.vue";
  import { getRegionList } from '@/api/v4ward/carv2/cargroup';
  export default {
    components: { refundForm,
      searchFromShow,
      AddForm ,
      PayForm,
      BreakPayApplyForm,
      ApproveForm,
      ViewForm,
      LeaseViewForm,
      EditForm,
      PayLog,
      ImportForm},
    data() {
      return {
        regionList: [],
        statusCountNew:{
          freeNum:"",
          outNum:"",
          normalNum:"",
          leasedNum:""
        },
        refundVisible:false,
        isImportDialogShow:false,
        payLogVisible:false,
        editFormVisible:false,
        viewFormVisible:false,
        leaseViewFormVisible:false,
        payFormVisible:false,
        breakPayApplyFormVisible:false,
        approveFormVisible:false,
        spaceStatusData:[
            {
                dictKey:'1',
                dictValue:'空闲',
            },
            {
                dictKey:'2',
                dictValue:'已出售',
            },
            {
                dictKey:'3',
                dictValue:'已出租',
            },
            {
                dictKey:'9',
                dictValue:'其他',
            },
        ],
        isDoubleData:[
            {
                dictKey:'0',
                dictValue:'否',
            },
            {
                dictKey:'1',
                dictValue:'是',
            },
        ],
        paymentStatusData:[
          {
            dictKey:'1',
            dictValue:'正常',
          },
          {
            dictKey:'2',
            dictValue:'已逾期',
          },
        ],
        parkingSpaceNatureDict:[
          {
            dictKey:'1',
            dictValue:'车位',
          },
          {
            dictKey:'2',
            dictValue:'车库',
          },
        ],
        printVisible: false,
        addFormVisible: false,
        rowInfo: {},
        searchForm: {
          spaceId: '',
          code: '',
          isDouble: '',
          parkingSpaceNature: '',
          searchPlateNumber: '',
          spaceStatus:'',
          paymentStatus:'',
          personName:'',
          personPhone:'',
          roomName:"",
          remainDays:"",
          buyEndTimeStart:"",
          buyEndTimeEnd:"",
          endTimeList:[]
        },
        option: {
          selection: true,
          select: false,
          index: true,
          indexFixed:false,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: true,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '所属车场',
              prop: 'spaceName',
              width:200,
              hide:true
            },
            {
              label: '车位编号',
              prop: 'name',
            },
            {
              label: '区域id',
              prop: 'regionId',
              showColumn: false,
              hide: true,
            },
            {
              label: '',
              prop: 'searchPlateNumber',
              showColumn: false,
              hide: true,
            },
            {
              label: '所属区域',
              prop: 'regionName',
              width:200,
            },
            {
              label: '子母车位',
              prop: 'isDouble',
              type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicData:[
            {
                dictKey:'0',
                dictValue:'否',
            },
            {
                dictKey:'1',
                dictValue:'是',
            },
            ],
            dataType: 'string',
            },
            {
              label: '车位性质',
              prop: 'parkingSpaceNature',
              type: 'select',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicData:[
                {
                  dictKey:'1',
                  dictValue:'车位',
                },
                {
                  dictKey:'2',
                  dictValue:'车库',
                },
              ],
              dataType: 'string',
            },
            {
              label: '车位状态',
              prop: 'spaceStatus',
              type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicData:[
            {
                dictKey:'1',
                dictValue:'空闲',
            },
            {
                dictKey:'2',
                dictValue:'已出售',
            },
            {
                dictKey:'3',
                dictValue:'已出租',
            },
            ],
            dataType: 'string',
            },
            {
              label: '面积',
              prop: 'area',
            },
            {
              label: '归属人姓名',
              prop: 'personName',
            },
            {
              label: '归属人电话',
              prop: 'personPhone',
            },
            {
              label: '房间名称',
              prop: 'roomName',
            },
            {
              label: '缴费状态',
              prop: 'paymentStatus',
              type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicData:[
            {
                dictKey:'1',
                dictValue:'正常',
            },
            {
                dictKey:'2',
                dictValue:'已逾期',
            },
              {
                dictKey:'3',
                dictValue:'申请断缴',
              },
            ],
            dataType: 'string',
            },
            {
              label: '出售日期',
              format: 'yyyy-MM-dd',
              width:100,
              type: 'date',
              prop: 'soldDay',
            },
            {
              label: '生效日期',
              format: 'yyyy-MM-dd',
              width:100,
              type: 'date',
              prop: 'effectTime',
            },
            {
              label: '有效期止',
              format: 'yyyy-MM-dd',
              width:100,
              type: 'date',
              prop: 'expiredTime',
            },{
              label: '剩余天数',
              prop: 'remainDays',
            },
          ],
        },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
        selectionList: [],
        recordIds: [],
        canteenList: [],
      };
    },
    created() {
      this.initData();
    },
    computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.spaceAdd, false),
        delBtn: this.vaildData(this.permission.spaceRemove, false),
        editBtn: this.vaildData(this.permission.spaceEdit, false),
        importBtn: this.vaildData(this.permission.spaceImport, false),
        refundBtn: this.vaildData(this.permission.spaceRefund, false),
        approveBtn: this.vaildData(this.permission.spaceApprove, false),
        breakApplyBtn: this.vaildData(this.permission.spaceBreakApply, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch:{
    '$route.path':function(newVal,oldVal){
     if(newVal === '/v4ward/carv2/carMaster/index'){
        this.$refs.crud.$refs.table.doLayout()
     }
    }
  },
    mounted() {
      this.calcHeight();
    },
    methods: {
      openRefundDialog() {
      if (this.selectionList.length==0||this.selectionList.length>1) {
        this.$message.warning('请选择一条数据进行操作');
        return;
      }
      if (this.selectionList[0].spaceStatus !=2 || this.selectionList[0].paymentStatus!= 1) {
        this.$message.warning('请选择状态为【正常】的车位进行退费操作');
        return;
      }
      this.formRow = this.selectionList[0];
      this.refundVisible = true;
    },
      selectionChange(list) {
      console.log('selectionChange(list) ===>', list);
      this.selectionList = list;
    },
      importSuccess(){
      this.isImportDialogShow =false
      this.onLoad()
    },
      uploadRecord(){
        this.isImportDialogShow = true
      },
      removeRecord(row){
        this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return spaceRemove({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
      },
      recordCancle() {
        this.addFormVisible =false;
        this.editFormVisible = false;
        this.viewFormVisible = false;
        this.refundVisible = false
        this.leaseViewFormVisible = false;
        this.payFormVisible = false;
        this.breakPayApplyFormVisible = false;
        this.approveFormVisible = false;
      },
      recordSuccess() {
        this.addFormVisible =false;
        this.refundVisible = false
        this.editFormVisible = false;
        this.viewFormVisible = false;
        this.leaseViewFormVisible = false;
        this.payFormVisible = false;
        this.breakPayApplyFormVisible = false;
        this.approveFormVisible = false;
        this.onLoad();
      },
      viewRecord(row) {
        this.formRow = row
        this.viewFormVisible = true
      },
      payRecord(row) {
        this.formRow = row
        this.payFormVisible = true
      },
      breakPayRecord(row) {
        this.formRow = row
        this.breakPayApplyFormVisible = true
      },
      approveRecord(row) {
        this.formRow = row
        this.approveFormVisible = true
      },
      payLogRecord(row){
        this.formRow = row
        this.payLogVisible = true
      },
      addRecord() {
        this.addFormVisible = true;
      },
      editRecord(row) {
        this.formRow = row
         this.editFormVisible = true
      },
      spaceIdChange(spaceId) {
        this.tool.clearObject(this.searchForm, 'spaceId');
        let self = this;
        this.searchForm = Object.assign({}, this.searchForm, {
          regionId: '',
        });
        getRegionList({ spaceId: this.searchForm.spaceId }).then((res) => {
          self.regionList = res.data;
          if (res.data.length > 0) {
            this.searchForm = Object.assign({}, this.searchForm, {
              regionId: res.data[0].id,
            });
          }
          this.$forceUpdate();
        });
        this.onLoad()
      },
      searchRecord() {
        this.page.currentPage = 1;



      //   if (this.searchForm.endTimeList && this.searchForm.endTimeList.length > 0) {
      //   this.searchForm.buyEndTimeStart = this.dayjs(this.searchForm.endTimeList[0]).format(
      //     'YYYY-MM-DD 00:00:00'
      //   );
      //   this.searchForm.buyEndTimeEnd = this.dayjs(this.searchForm.endTimeList[1]).format(
      //     'YYYY-MM-DD 23:59:59'
      //   );
      // } else {
      //   this.searchForm.endTimeList = [];
      //   this.searchForm.buyEndTimeStart = '';
      //   this.searchForm.buyEndTimeEnd = '';
      // }
        this.onLoad();
      },
      searchClear() {
        this.tool.clearObject(this.searchForm, 'spaceId');
      },
      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },
      async initData() {
        await getParkList().then((res) => {
          let self = this;
          this.spaceIdList = res.data;
          if (this.spaceIdList.length > 0) {
            this.$set(this.searchForm, 'spaceId', this.spaceIdList[0].id);
            getRegionList({ spaceId: this.searchForm.spaceId }).then((res) => {
              self.regionList = res.data;
              if (res.data.length > 0) {
                this.searchForm = Object.assign({}, this.searchForm, {
                  regionId: res.data[0].id,
                });
              }
              this.$forceUpdate();
            });
            this.onLoad();
          }
        });
      },
      onLoad() {
        if (this.searchForm.spaceId != '') {
          this.loading = true;
          spaceStatusCount(this.searchForm).then(res=>{
          this.statusCountNew = res.data
          console.log("//////////////////",res.data)
        })
          spacePage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
    },
  };
  </script>
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }
  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #alarmRule > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
